export const ENTITIES_KEY_PROCESS = 'processes';
